
<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-profile-sidebar w-full sm:w-25rem">
    <div class="flex flex-column mx-auto md:mx-0">
        <p-toast></p-toast>
        <span class="mb-2 font-semibold">Assistenza</span>
        <span class="text-color-secondary font-medium mb-5">Utente {{userlogged.firstName + " " + userlogged.lastName}}</span>

        <ul class="list-none m-0 p-0">
            <li>
                <a class="flex surface-border mb-2 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <div class="w-full">
                        <div class="flex gap-3 mb-2">
                            <i class="pi pi-clock text-xl text-primary"></i>
                            <span class="font-semibold">Messaggio </span>
                        </div>
                        <div>
                            <textarea id="message" rows="5" pInputTextarea class="w-full mt-2 p-2 text-900 font-semibold border-round" style="min-height: 44px;" [autoResize]="true" [(ngModel)]="message"></textarea>
                            <p class="cursor-pointer text-right text-primary m-0" (click)="sendMessage()">Invia Messaggio</p>
                        </div>
                        
                    </div>
                </a>
            </li>
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-phone text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Chiamaci</span>
                        <p class="text-color-secondary m-0">Contact Center<br>al numero +39.0833.505393</p>
                    </div>
                </a>
            </li>
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-clock text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Orario</span>
                        <p class="text-color-secondary m-0">Dal lunedi al venerdì<br>Mattina: 9:00-13:00<br>Pomeriggio: 14:00-18:00</p>
                    </div>
                </a>
            </li>
            <li>
                <a class="cursor-pointer flex surface-border mb-3 p-3 align-items-center border-1 surface-border border-round hover:surface-hover transition-colors transition-duration-150">
                    <span>
                        <i class="pi pi-clock text-xl text-primary"></i>
                    </span>
                    <div class="ml-3">
                        <span class="mb-2 font-semibold">Sede</span>
                        <p class="text-color-secondary m-0">Italset S.r.l. Sede legale: Via Giuseppe Sansonetti, 20<br>73042 Casarano (LE) - CF e P.IVA 03890260759</p>
                    </div>
                </a>
            </li>
        </ul>
    
    </div>
   
</p-sidebar>